module.exports = __webpack_public_path__ + "static/media/mac_screen_1.c8524f53.jpg";